














import { Vue, Component } from 'vue-property-decorator';
import Axios from 'axios';
import _ from 'underscore';

@Component
export default class DiscordLabel extends Vue {
  public fetchStatus: -1 | 0 | string = -1;
  public lastFetch = Date.now();
  
  public mounted() {
    this.fetch();
  }
  public fetch() {
    this.lastFetch = Date.now();
    this.fetchStatus = 0;
    Axios.get('https://discordapp.com/api/guilds/557628151837229074/widget.json')
    .then((res) => {
      const body = res.data as {
        channels: any,
        id: number;
        name: string;
        members: Array<{ username: string; status: 'online' | 'offline' }>;
      };

      let onlineMembers = 0;
      _.each(body.members, (user) => {
        if (user.status === 'online') {
          onlineMembers++;
        }
      });
      this.fetchStatus = `${onlineMembers} USERS ONLINE`;
    })
    .catch(() => {
      this.fetchStatus = -1;
    });
  }
  public updated() {
    const deltaTime = Date.now() - this.lastFetch;

    // fetch every 8 seconds
    if (deltaTime >= 8000 && this.fetchStatus !== 0) {
      this.fetch();
    }
  }
}
